var React = require('react');

function PhoneMessage (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0a7.5 7.5 0 00-7.5 7.5v9A7.5 7.5 0 0024 24h6v6a1.5 1.5 0 002.56 1.06L39.622 24h.879a7.5 7.5 0 007.5-7.5v-9A7.5 7.5 0 0040.5 0H24zm-4.5 7.5A4.5 4.5 0 0124 3h16.5A4.5 4.5 0 0145 7.5v9a4.5 4.5 0 01-4.5 4.5H39a1.5 1.5 0 00-1.06.44L33 26.378V22.5a1.5 1.5 0 00-1.5-1.5H24a4.5 4.5 0 01-4.5-4.5v-9z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.966 3H12a1.5 1.5 0 010 3H6.967A3.97 3.97 0 003 9.967V36h21v-7.5a1.5 1.5 0 013 0v12.536A6.964 6.964 0 0120.036 48H6.966A6.967 6.967 0 010 41.037V9.966A6.971 6.971 0 016.966 3zM3 41.035V39h21v2.036A3.964 3.964 0 0120.036 45H6.966A3.967 3.967 0 013 41.035z","key":1})]);
}

PhoneMessage.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = PhoneMessage;

PhoneMessage.default = PhoneMessage;
